import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Button, ModalBody, ModalFooter } from 'reactstrap';

import { setUserSetting, updateUserSettings } from '../../actions/Auth';

import { getCurrentUser, userIsAdmin, userIsManager } from '../../helpers/Auth';

import ErrorBoundary from '../ErrorBoundary';

const FileUploadedModal = ({
  handleClose, fileCount, collection,
}) => {
  const intl = useIntl();

  if (!(userIsAdmin() || userIsManager())) {
    return null;
  }

  return (
    <ErrorBoundary>
      <ModalBody>
        <h4>
          {intl.formatMessage({ defaultMessage: 'Nice work!' })}
        </h4>
        <p>
          {collection ?
            intl.formatMessage(
              { defaultMessage: 'Your {fileCount, plural, one {file has} other {files have}} been uploaded to <strong>{collectionName}</strong>.' },
              { fileCount, collectionName: collection.name },
            ) :
            intl.formatMessage(
              { defaultMessage: 'Your {fileCount, plural, one {file has} other {files have}} been uploaded.' },
              { fileCount },
            )}
        </p>
      </ModalBody>
      <ModalFooter>
        <div className="buttons-group">
          <Button
            color="link"
            onClick={handleClose}
            className="mr-2"
          >
            {intl.formatMessage({ defaultMessage: 'Close' })}
          </Button>
          {collection ? (
            <Button
              color="primary"
              tag={Link}
              to={`/collections/${collection.uuid}`}
              onClick={handleClose}
            >
              {intl.formatMessage({ defaultMessage: 'Go to Collection' })}
            </Button>
          )
            : (
              <Button
                color="primary"
                tag={Link}
                to="/files"
                onClick={handleClose}
              >
                {intl.formatMessage({ defaultMessage: 'Browse all files' })}
              </Button>
            )}
        </div>
      </ModalFooter>
    </ErrorBoundary>
  );
};

const mapDispatchToProps = (dispatch) => ({
  handleUserSetting: (setting) => {
    const profile = getCurrentUser();
    if (profile) {
      dispatch(setUserSetting(setting));
      dispatch(updateUserSettings(profile.uuid, setting));
    }
  },
});

FileUploadedModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  fileCount: PropTypes.number.isRequired,
  collection: PropTypes.object,
};

FileUploadedModal.defaultProps = {
  collection: null,
};

export default connect(null, mapDispatchToProps)(FileUploadedModal);
